var _rect, _g, _path, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _g3, _g4, _path8, _circle, _circle2, _circle3, _rect2, _path9, _path10, _path11, _path12, _path13, _path14, _g5, _path15, _path16, _path17, _path18, _path19, _path20, _g6, _path21, _g7, _g8, _path22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMemberDiamond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 171,
    viewBox: "0 0 324 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_374_97367)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_374_97367)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.668945,
    width: 324,
    height: 170.331,
    rx: 12.0343,
    fill: "url(#paint0_linear_374_97367)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_374_97367)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 144.29,
    cy: 115.58,
    r: 71.3694,
    stroke: "url(#paint1_linear_374_97367)",
    strokeOpacity: 0.08,
    strokeWidth: 24.1346
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.456,
    cy: -13.7187,
    r: 85.8271,
    stroke: "url(#paint2_linear_374_97367)",
    strokeOpacity: 0.08,
    strokeWidth: 29.0236
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_374_97367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.32 -4.88543C220.32 52.3755 173.901 98.7946 116.64 98.7946C59.3791 98.7946 12.96 52.3755 12.96 -4.88543C12.96 -62.1463 59.3791 -108.565 116.64 -108.565C173.901 -108.565 220.32 -62.1463 220.32 -4.88543Z",
    fill: "url(#paint3_radial_374_97367)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 320.856,
    cy: 220.622,
    r: 102.481,
    stroke: "url(#paint4_linear_374_97367)",
    strokeOpacity: 0.08,
    strokeWidth: 38.6935
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M366.194 23.5383C386.615 51.7683 373.736 94.5986 337.753 120.628C301.868 146.587 258.296 144.264 237.819 115.957C217.236 87.5034 227.223 41.9449 262.929 16.1151C298.637 -9.7156 345.611 -4.91448 366.194 23.5383Z",
    stroke: "#1D0452",
    strokeWidth: 6.46129
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M360.2 8.87626C389.995 44.1854 382.299 86.8792 340.851 120.517C298.174 151.985 251.879 144.394 227.546 113.444C203.213 82.4934 212.137 31.0455 249.927 3.70892C287.716 -23.6277 337.782 -22.1135 360.2 8.87626Z",
    fill: "url(#paint5_linear_374_97367)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M355.843 8.05579C366.08 22.2062 367.773 40.0091 362.241 57.7807C356.7 75.576 343.934 93.1871 325.555 106.482C288.59 133.222 244.247 131.37 223.811 103.12C203.271 74.7264 213.96 28.5691 250.745 1.95905C287.531 -24.6519 335.304 -20.337 355.843 8.05579Z",
    stroke: "#20046B",
    strokeWidth: 6.46129
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M347.59 8.10005C364.519 31.5027 355.012 71.7831 319.573 97.4199C284.133 123.057 242.9 119.481 225.971 96.0783C209.042 72.6756 218.549 32.3953 253.989 6.75843C289.428 -18.8784 330.661 -15.3026 347.59 8.10005Z",
    fill: "url(#paint6_linear_374_97367)",
    stroke: "url(#paint7_linear_374_97367)",
    strokeWidth: 17.948
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M338.91 14.4083C346.197 24.4827 347.156 37.85 342.578 51.456C338.001 65.0586 327.915 78.7753 313.354 89.3093C298.792 99.8433 282.608 105.13 268.256 105.22C253.901 105.31 241.505 100.216 234.217 90.1421C226.929 80.0677 225.97 66.7003 230.549 53.0944C235.126 39.4917 245.211 25.775 259.773 15.241C274.335 4.70705 290.519 -0.579367 304.871 -0.66974C319.226 -0.760135 331.622 4.33388 338.91 14.4083Z",
    fill: "#2C0263",
    stroke: "url(#paint8_linear_374_97367)",
    strokeWidth: 2.87168
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_374_97367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.786 47.728L378.34 64.547C381.61 45.3291 374.46 29.9472 371.65 25.68C369.426 21.5115 365.3 15.656 360.441 9.23124C347.545 -10.9302 320.361 -28.912 278.102 -15.4846C227.842 1.80048 211.183 42.5319 209.396 60.5175L363.49 45.7588L367.786 47.728Z",
    fill: "#160539",
    fillOpacity: 0.08
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M291.107 88.4702L254.601 61.2299L317.655 69.0684L291.107 88.4702Z",
    fill: "#3C0682",
    stroke: "#2C0263",
    strokeWidth: 0.925714
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M254.197 60.7696L301.212 34.6L290.531 87.4742L254.197 60.7696Z",
    fill: "#3C0682",
    stroke: "#2C0263",
    strokeWidth: 0.925714
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_374_97367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.653 47.9454C280.062 45.5357 283.01 43.1966 296.218 36.9291C290.252 41.1459 280.469 46.6541 276.653 47.9454Z",
    fill: "#3C0682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.653 47.9454C280.062 45.5357 283.01 43.1966 296.218 36.9291C290.252 41.1459 280.469 46.6541 276.653 47.9454Z",
    stroke: "#2C0263",
    strokeWidth: 0.925714
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_374_97367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.257 84.1709C273.272 73.7245 269.453 61.0866 272.321 50.4965C282.341 55.8125 287.675 78.3943 285.257 84.1709Z",
    fill: "#3C0682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.257 84.1709C273.272 73.7245 269.453 61.0866 272.321 50.4965C282.341 55.8125 287.675 78.3943 285.257 84.1709Z",
    stroke: "#2C0263",
    strokeWidth: 0.925714
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M253.341 60.7148L284.724 83.7799L263.932 29.585L253.341 60.7148Z",
    fill: "#3C0682",
    stroke: "#2C0263",
    strokeWidth: 0.925714
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 301.403,
    cy: 33.7749,
    r: 4.05936,
    transform: "rotate(36.3143 301.403 33.7749)",
    fill: "#3C0682",
    stroke: "#2C0263",
    strokeWidth: 0.462857
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.193,
    cy: 69.1391,
    r: 3.39924,
    transform: "rotate(36.3143 317.193 69.1391)",
    fill: "#3C0682",
    stroke: "#2C0263",
    strokeWidth: 0.462857
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.15,
    cy: 30.155,
    r: 3.39924,
    transform: "rotate(-8.68571 264.15 30.155)",
    fill: "#3C0682",
    stroke: "#2C0263",
    strokeWidth: 0.462857
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5146,
    y: 47.8232,
    width: 23.1429,
    height: 23.1429,
    rx: 11.5714,
    fill: "url(#paint9_radial_374_97367)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1484 58.7772L29.777 52.8262L27.7933 58.7772H25.1484Z",
    fill: "url(#paint10_linear_374_97367)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7939 58.7772L29.7776 52.8262L31.7613 58.7772H27.7939Z",
    fill: "url(#paint11_linear_374_97367)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7773 52.8262L31.761 58.7772H34.4059L29.7773 52.8262Z",
    fill: "url(#paint12_linear_374_97367)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.777 64.7284L25.1484 58.7773H27.7933L29.777 64.7284Z",
    fill: "url(#paint13_linear_374_97367)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7613 58.7773H27.7939L29.7776 64.7284L31.7613 58.7773Z",
    fill: "url(#paint14_linear_374_97367)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.761 58.7773H34.4059L29.7773 64.7284L31.761 58.7773Z",
    fill: "url(#paint15_linear_374_97367)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_374_97367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1484 58.7772L29.777 52.8262L27.7933 58.7772H25.1484Z",
    fill: "#0C021E",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.777 52.8262L31.7607 58.7772H34.4056L29.777 52.8262Z",
    fill: "#0C021E",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7933 58.7772L29.777 52.8262L31.7607 58.7772H27.7933Z",
    fill: "#0C021E",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.777 64.7282L25.1484 58.7772H27.7933L29.777 64.7282Z",
    fill: "#0C021E",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7607 58.7772H34.4056L29.777 64.7282L31.7607 58.7772Z",
    fill: "#0C021E",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7607 58.7772H27.7933L29.777 64.7282L31.7607 58.7772Z",
    fill: "#0C021E",
    fillOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_374_97367)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_374_97367",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 52,
    width: 10,
    height: 13
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1484 58.7772L29.777 52.8262L27.7933 58.7772H25.1484Z",
    fill: "url(#paint16_linear_374_97367)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.777 52.8262L31.7607 58.7772H34.4056L29.777 52.8262Z",
    fill: "url(#paint17_linear_374_97367)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7933 58.7772L29.777 52.8262L31.7607 58.7772H27.7933Z",
    fill: "url(#paint18_linear_374_97367)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.777 64.7282L25.1484 58.7772H27.7933L29.777 64.7282Z",
    fill: "url(#paint19_linear_374_97367)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7607 58.7772H34.4056L29.777 64.7282L31.7607 58.7772Z",
    fill: "url(#paint20_linear_374_97367)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7607 58.7772H27.7933L29.777 64.7282L31.7607 58.7772Z",
    fill: "url(#paint21_linear_374_97367)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_374_97367)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_b_374_97367)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7909 52.8306L27.8072 58.7816L27.7793 58.7723L29.763 52.8213L29.7909 52.8306Z",
    fill: "url(#paint22_linear_374_97367)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7627 64.7235L31.7464 58.7725L31.7742 58.7818L29.7906 64.7328L29.7627 64.7235Z",
    fill: "url(#paint23_linear_374_97367)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_374_97367)",
    filter: "url(#filter7_f_374_97367)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_374_97367",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 52,
    width: 5,
    height: 7
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7483 52.8262L27.7646 58.7258H31.7834L29.7483 52.8262Z",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.0146939
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_374_97367)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.1953,
    y: 33.9453,
    width: 0.861728,
    height: 46.9824,
    transform: "rotate(30.433 42.1953 33.9453)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.8672,
    y: 35.8389,
    width: 1.27325,
    height: 45.5408,
    transform: "rotate(30.433 42.8672 35.8389)",
    fill: "white",
    fillOpacity: 0.2
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_374_97367)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.7769,
    cy: 53.273,
    rx: 0.330612,
    ry: 0.446843,
    fill: "url(#paint24_linear_374_97367)"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8144 65.8945V63.5951H56.7304C57.4413 63.5951 58.0634 63.4562 58.5966 63.1785C59.1298 62.8897 59.5408 62.4731 59.8297 61.9288C60.1185 61.3845 60.2629 60.7402 60.2629 59.9959C60.2629 59.2516 60.1129 58.6129 59.813 58.0797C59.5242 57.5464 59.1132 57.1354 58.58 56.8466C58.0579 56.5578 57.4413 56.4134 56.7304 56.4134H53.7311V54.1306H56.7637C57.6524 54.1306 58.4689 54.275 59.2131 54.5638C59.9685 54.8415 60.6239 55.247 61.1794 55.7802C61.7459 56.3023 62.1791 56.9244 62.4791 57.6464C62.7901 58.3574 62.9456 59.1461 62.9456 60.0125C62.9456 60.8679 62.7901 61.6566 62.4791 62.3787C62.1791 63.1007 61.7515 63.7228 61.196 64.2449C60.6406 64.767 59.9852 65.1725 59.2298 65.4613C58.4855 65.7501 57.6746 65.8945 56.797 65.8945H53.8144ZM52.0481 65.8945V54.1306H54.6642V65.8945H52.0481ZM64.3771 65.8945V57.7964H66.9265V65.8945H64.3771ZM65.6601 56.68C65.2602 56.68 64.9269 56.5467 64.6603 56.2801C64.4048 56.0023 64.2771 55.6691 64.2771 55.2803C64.2771 54.8804 64.4048 54.5471 64.6603 54.2805C64.9269 54.0139 65.2602 53.8806 65.6601 53.8806C66.06 53.8806 66.3877 54.0139 66.6432 54.2805C66.8987 54.5471 67.0265 54.8804 67.0265 55.2803C67.0265 55.6691 66.8987 56.0023 66.6432 56.2801C66.3877 56.5467 66.06 56.68 65.6601 56.68ZM72.1043 66.0612C71.3601 66.0612 70.6935 65.8779 70.1048 65.5113C69.5271 65.1447 69.0661 64.6448 68.7218 64.0116C68.3885 63.3784 68.2219 62.6564 68.2219 61.8455C68.2219 61.0345 68.3885 60.3125 68.7218 59.6793C69.0661 59.0461 69.5271 58.5462 70.1048 58.1796C70.6935 57.813 71.3601 57.6298 72.1043 57.6298C72.6487 57.6298 73.1374 57.7353 73.5707 57.9463C74.015 58.1574 74.376 58.4518 74.6538 58.8295C74.9315 59.1961 75.087 59.6182 75.1203 60.0959V63.5951C75.087 64.0727 74.9315 64.5004 74.6538 64.8781C74.3871 65.2447 74.0317 65.5335 73.5873 65.7446C73.143 65.9556 72.6487 66.0612 72.1043 66.0612ZM72.6209 63.7617C73.1652 63.7617 73.604 63.5839 73.9373 63.2285C74.2705 62.8619 74.4371 62.4009 74.4371 61.8455C74.4371 61.4678 74.3594 61.1345 74.2039 60.8457C74.0594 60.5569 73.8484 60.3347 73.5707 60.1792C73.3041 60.0125 72.993 59.9292 72.6375 59.9292C72.2821 59.9292 71.9655 60.0125 71.6878 60.1792C71.4212 60.3347 71.2045 60.5569 71.0379 60.8457C70.8824 61.1345 70.8046 61.4678 70.8046 61.8455C70.8046 62.212 70.8824 62.5397 71.0379 62.8286C71.1934 63.1174 71.4101 63.3451 71.6878 63.5117C71.9655 63.6784 72.2765 63.7617 72.6209 63.7617ZM74.3372 65.8945V63.7117L74.7204 61.7455L74.3372 59.7793V57.7964H76.8366V65.8945H74.3372ZM78.6316 65.8945V57.7964H81.181V65.8945H78.6316ZM83.8138 65.8945V61.1623C83.8138 60.7513 83.686 60.4347 83.4305 60.2125C83.1861 59.9792 82.8806 59.8626 82.5141 59.8626C82.2586 59.8626 82.0308 59.9181 81.8309 60.0292C81.6309 60.1292 81.4699 60.2736 81.3477 60.4624C81.2366 60.6513 81.181 60.8846 81.181 61.1623L80.1979 60.729C80.1979 60.0847 80.3368 59.5349 80.6145 59.0794C80.8922 58.6129 81.2699 58.2574 81.7476 58.013C82.2252 57.7575 82.764 57.6298 83.3639 57.6298C83.9304 57.6298 84.4358 57.7575 84.8802 58.013C85.3356 58.2685 85.6967 58.624 85.9633 59.0794C86.2299 59.5349 86.3632 60.0792 86.3632 60.7124V65.8945H83.8138ZM88.9959 65.8945V61.1623C88.9959 60.7513 88.8682 60.4347 88.6127 60.2125C88.3683 59.9792 88.0628 59.8626 87.6962 59.8626C87.4407 59.8626 87.213 59.9181 87.013 60.0292C86.8131 60.1292 86.652 60.2736 86.5298 60.4624C86.4187 60.6513 86.3632 60.8846 86.3632 61.1623L84.8969 60.9623C84.9191 60.2736 85.0801 59.6848 85.3801 59.1961C85.6911 58.6962 86.0966 58.3129 86.5965 58.0463C87.1075 57.7686 87.6796 57.6298 88.3127 57.6298C88.9348 57.6298 89.4847 57.7631 89.9624 58.0297C90.4511 58.2852 90.8344 58.6573 91.1121 59.1461C91.4009 59.6237 91.5453 60.2014 91.5453 60.879V65.8945H88.9959ZM97.0782 66.0778C96.245 66.0778 95.4897 65.8945 94.812 65.5279C94.1455 65.1503 93.6179 64.6393 93.2291 63.995C92.8403 63.3507 92.6459 62.6286 92.6459 61.8288C92.6459 61.029 92.8403 60.3125 93.2291 59.6793C93.6179 59.0461 94.1455 58.5462 94.812 58.1796C95.4785 57.8019 96.2339 57.6131 97.0782 57.6131C97.9224 57.6131 98.6778 57.7964 99.3443 58.163C100.011 58.5295 100.539 59.035 100.927 59.6793C101.316 60.3125 101.511 61.029 101.511 61.8288C101.511 62.6286 101.316 63.3507 100.927 63.995C100.539 64.6393 100.011 65.1503 99.3443 65.5279C98.6778 65.8945 97.9224 66.0778 97.0782 66.0778ZM97.0782 63.7617C97.4448 63.7617 97.7669 63.6839 98.0446 63.5284C98.3223 63.3618 98.5334 63.1341 98.6778 62.8452C98.8333 62.5453 98.9111 62.2065 98.9111 61.8288C98.9111 61.4511 98.8333 61.1234 98.6778 60.8457C98.5223 60.5569 98.3057 60.3347 98.028 60.1792C97.7614 60.0125 97.4448 59.9292 97.0782 59.9292C96.7227 59.9292 96.4061 60.0125 96.1284 60.1792C95.8507 60.3347 95.6341 60.5569 95.4785 60.8457C95.323 61.1345 95.2453 61.4678 95.2453 61.8455C95.2453 62.212 95.323 62.5453 95.4785 62.8452C95.6341 63.1341 95.8507 63.3618 96.1284 63.5284C96.4061 63.6839 96.7227 63.7617 97.0782 63.7617ZM108.129 65.8945V61.2789C108.129 60.8568 107.995 60.518 107.729 60.2625C107.473 59.9959 107.145 59.8626 106.746 59.8626C106.468 59.8626 106.223 59.9237 106.012 60.0459C105.801 60.157 105.635 60.3236 105.512 60.5458C105.39 60.7568 105.329 61.0012 105.329 61.2789L104.346 60.7957C104.346 60.1625 104.485 59.6071 104.763 59.1294C105.04 58.6517 105.424 58.2852 105.912 58.0297C106.412 57.7631 106.973 57.6298 107.595 57.6298C108.195 57.6298 108.723 57.7742 109.178 58.063C109.645 58.3407 110.011 58.7128 110.278 59.1794C110.545 59.646 110.678 60.157 110.678 60.7124V65.8945H108.129ZM102.78 65.8945V57.7964H105.329V65.8945H102.78ZM115.765 66.0612C114.998 66.0612 114.315 65.8779 113.715 65.5113C113.126 65.1447 112.66 64.6448 112.315 64.0116C111.982 63.3784 111.815 62.6564 111.815 61.8455C111.815 61.0345 111.982 60.3125 112.315 59.6793C112.66 59.0461 113.126 58.5462 113.715 58.1796C114.315 57.813 114.998 57.6298 115.765 57.6298C116.32 57.6298 116.82 57.7353 117.264 57.9463C117.72 58.1574 118.092 58.4518 118.381 58.8295C118.681 59.1961 118.847 59.6182 118.88 60.0959V63.5117C118.847 63.9894 118.686 64.4226 118.397 64.8114C118.108 65.1891 117.736 65.4946 117.281 65.7279C116.825 65.9501 116.32 66.0612 115.765 66.0612ZM116.214 63.7617C116.581 63.7617 116.898 63.6839 117.164 63.5284C117.431 63.3618 117.642 63.1341 117.797 62.8452C117.953 62.5564 118.031 62.2231 118.031 61.8455C118.031 61.4678 117.953 61.1401 117.797 60.8623C117.653 60.5735 117.442 60.3458 117.164 60.1792C116.898 60.0125 116.587 59.9292 116.231 59.9292C115.876 59.9292 115.559 60.0125 115.281 60.1792C115.015 60.3458 114.798 60.5735 114.631 60.8623C114.476 61.1512 114.398 61.4789 114.398 61.8455C114.398 62.212 114.476 62.5397 114.631 62.8286C114.787 63.1174 115.004 63.3451 115.281 63.5117C115.559 63.6784 115.87 63.7617 116.214 63.7617ZM120.43 65.8945H117.931V63.7117L118.314 61.7455L117.881 59.7793V53.7973H120.43V65.8945ZM125.632 65.8945V54.1306H127.498L132.13 61.3456H131.18L135.796 54.1306H137.679V65.8945H135.063V58.5462L135.529 58.6629L132.513 63.3618H130.78L127.781 58.6629L128.231 58.5462V65.8945H125.632ZM143.701 66.0778C142.823 66.0778 142.04 65.9001 141.351 65.5446C140.674 65.178 140.14 64.6726 139.752 64.0283C139.363 63.384 139.168 62.6564 139.168 61.8455C139.168 61.0345 139.357 60.3125 139.735 59.6793C140.124 59.035 140.646 58.5295 141.301 58.163C141.957 57.7964 142.695 57.6131 143.517 57.6131C144.317 57.6131 145.023 57.7853 145.634 58.1296C146.245 58.474 146.722 58.9517 147.067 59.5626C147.422 60.1736 147.6 60.8735 147.6 61.6622C147.6 61.8066 147.589 61.9621 147.567 62.1287C147.555 62.2842 147.528 62.4675 147.483 62.6786L140.501 62.6953V60.9457L146.4 60.929L145.3 61.6622C145.289 61.1956 145.217 60.8124 145.084 60.5124C144.95 60.2014 144.75 59.9681 144.484 59.8126C144.228 59.646 143.912 59.5626 143.534 59.5626C143.134 59.5626 142.784 59.6571 142.484 59.8459C142.196 60.0237 141.968 60.2791 141.801 60.6124C141.646 60.9457 141.568 61.3511 141.568 61.8288C141.568 62.3065 141.651 62.7175 141.818 63.0618C141.996 63.3951 142.24 63.6562 142.551 63.845C142.873 64.0227 143.251 64.1116 143.684 64.1116C144.084 64.1116 144.445 64.045 144.767 63.9117C145.089 63.7672 145.373 63.5562 145.617 63.2785L147.017 64.6781C146.617 65.1447 146.134 65.4946 145.567 65.7279C145 65.9612 144.378 66.0778 143.701 66.0778ZM148.83 65.8945V57.7964H151.38V65.8945H148.83ZM154.013 65.8945V61.1623C154.013 60.7513 153.885 60.4347 153.629 60.2125C153.385 59.9792 153.079 59.8626 152.713 59.8626C152.457 59.8626 152.23 59.9181 152.03 60.0292C151.83 60.1292 151.669 60.2736 151.546 60.4624C151.435 60.6513 151.38 60.8846 151.38 61.1623L150.397 60.729C150.397 60.0847 150.536 59.5349 150.813 59.0794C151.091 58.6129 151.469 58.2574 151.946 58.013C152.424 57.7575 152.963 57.6298 153.563 57.6298C154.129 57.6298 154.635 57.7575 155.079 58.013C155.534 58.2685 155.895 58.624 156.162 59.0794C156.429 59.5349 156.562 60.0792 156.562 60.7124V65.8945H154.013ZM159.195 65.8945V61.1623C159.195 60.7513 159.067 60.4347 158.811 60.2125C158.567 59.9792 158.262 59.8626 157.895 59.8626C157.64 59.8626 157.412 59.9181 157.212 60.0292C157.012 60.1292 156.851 60.2736 156.729 60.4624C156.618 60.6513 156.562 60.8846 156.562 61.1623L155.096 60.9623C155.118 60.2736 155.279 59.6848 155.579 59.1961C155.89 58.6962 156.295 58.3129 156.795 58.0463C157.306 57.7686 157.878 57.6298 158.512 57.6298C159.134 57.6298 159.683 57.7631 160.161 58.0297C160.65 58.2852 161.033 58.6573 161.311 59.1461C161.6 59.6237 161.744 60.2014 161.744 60.879V65.8945H159.195ZM168.043 66.0612C167.499 66.0612 166.999 65.9501 166.544 65.7279C166.088 65.4946 165.716 65.1891 165.427 64.8114C165.139 64.4226 164.972 63.9894 164.928 63.5117V60.0959C164.972 59.6182 165.139 59.1961 165.427 58.8295C165.716 58.4518 166.088 58.1574 166.544 57.9463C166.999 57.7353 167.499 57.6298 168.043 57.6298C168.81 57.6298 169.488 57.813 170.076 58.1796C170.676 58.5462 171.143 59.0461 171.476 59.6793C171.82 60.3125 171.993 61.0345 171.993 61.8455C171.993 62.6564 171.82 63.3784 171.476 64.0116C171.143 64.6448 170.676 65.1447 170.076 65.5113C169.488 65.8779 168.81 66.0612 168.043 66.0612ZM167.594 63.7617C167.949 63.7617 168.26 63.6784 168.527 63.5117C168.804 63.3451 169.021 63.1174 169.177 62.8286C169.332 62.5397 169.41 62.212 169.41 61.8455C169.41 61.4678 169.332 61.1345 169.177 60.8457C169.021 60.5569 168.804 60.3347 168.527 60.1792C168.26 60.0125 167.949 59.9292 167.594 59.9292C167.238 59.9292 166.922 60.0125 166.644 60.1792C166.366 60.3347 166.149 60.5569 165.994 60.8457C165.85 61.1345 165.777 61.4678 165.777 61.8455C165.777 62.2231 165.855 62.5564 166.011 62.8452C166.166 63.1341 166.377 63.3618 166.644 63.5284C166.922 63.6839 167.238 63.7617 167.594 63.7617ZM163.378 65.8945V53.7973H165.927V59.7793L165.511 61.7455L165.894 63.7117V65.8945H163.378ZM177.287 66.0778C176.409 66.0778 175.626 65.9001 174.937 65.5446C174.26 65.178 173.726 64.6726 173.338 64.0283C172.949 63.384 172.754 62.6564 172.754 61.8455C172.754 61.0345 172.943 60.3125 173.321 59.6793C173.71 59.035 174.232 58.5295 174.887 58.163C175.543 57.7964 176.281 57.6131 177.104 57.6131C177.903 57.6131 178.609 57.7853 179.22 58.1296C179.831 58.474 180.308 58.9517 180.653 59.5626C181.008 60.1736 181.186 60.8735 181.186 61.6622C181.186 61.8066 181.175 61.9621 181.153 62.1287C181.141 62.2842 181.114 62.4675 181.069 62.6786L174.088 62.6953V60.9457L179.986 60.929L178.886 61.6622C178.875 61.1956 178.803 60.8124 178.67 60.5124C178.537 60.2014 178.337 59.9681 178.07 59.8126C177.814 59.646 177.498 59.5626 177.12 59.5626C176.72 59.5626 176.37 59.6571 176.07 59.8459C175.782 60.0237 175.554 60.2791 175.387 60.6124C175.232 60.9457 175.154 61.3511 175.154 61.8288C175.154 62.3065 175.237 62.7175 175.404 63.0618C175.582 63.3951 175.826 63.6562 176.137 63.845C176.459 64.0227 176.837 64.1116 177.27 64.1116C177.67 64.1116 178.031 64.045 178.353 63.9117C178.675 63.7672 178.959 63.5562 179.203 63.2785L180.603 64.6781C180.203 65.1447 179.72 65.4946 179.153 65.7279C178.586 65.9612 177.964 66.0778 177.287 66.0778ZM182.416 65.8945V57.7964H184.966V65.8945H182.416ZM184.966 61.4455L183.899 60.6124C184.111 59.6682 184.466 58.935 184.966 58.4129C185.466 57.8908 186.16 57.6298 187.049 57.6298C187.438 57.6298 187.776 57.6909 188.065 57.813C188.365 57.9241 188.626 58.1019 188.848 58.3463L187.332 60.2625C187.221 60.1403 187.082 60.0459 186.915 59.9792C186.749 59.9126 186.56 59.8792 186.349 59.8792C185.927 59.8792 185.588 60.0125 185.332 60.2791C185.088 60.5346 184.966 60.9234 184.966 61.4455Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_374_97367",
    x: -11,
    y: -6.33105,
    width: 346,
    height: 192.331,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_374_97367"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0375 0 0 0 0 0.0328125 0 0 0 0 0.0328125 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_374_97367"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_374_97367",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_374_97367",
    x: -46.6972,
    y: -168.223,
    width: 326.675,
    height: 326.675,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 29.8286,
    result: "effect1_foregroundBlur_374_97367"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_374_97367",
    x: 208.47,
    y: -21.0546,
    width: 171.635,
    height: 86.5272,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.462857,
    result: "effect1_foregroundBlur_374_97367"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_374_97367",
    x: 274.534,
    y: 34.6593,
    width: 23.8025,
    height: 15.5759,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.925714,
    result: "effect1_foregroundBlur_374_97367"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_374_97367",
    x: 261.692,
    y: 40.5593,
    width: 33.8629,
    height: 53.6393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.62857,
    result: "effect1_foregroundBlur_374_97367"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_374_97367",
    x: 25.1484,
    y: 52.7086,
    width: 9.25684,
    height: 12.1521,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.132245
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117551
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_374_97367"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.117551
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.36
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_374_97367",
    result: "effect2_innerShadow_374_97367"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_374_97367",
    x: 27.1915,
    y: 52.2335,
    width: 3.18723,
    height: 7.13547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.293878
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_374_97367"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_374_97367",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_374_97367",
    x: 27.412,
    y: 52.4735,
    width: 4.72386,
    height: 6.60472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.176327,
    result: "effect1_foregroundBlur_374_97367"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_374_97367",
    x: 28.7851,
    y: 52.1649,
    width: 1.98358,
    height: 2.216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.330612,
    result: "effect1_foregroundBlur_374_97367"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_374_97367",
    x1: 54.6171,
    y1: -7.46051,
    x2: 188.809,
    y2: 205.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#051C66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#031E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692555,
    stopColor: "#0C2E75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E0C64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_374_97367",
    x1: 144.29,
    y1: 32.1436,
    x2: 129.982,
    y2: 195.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_374_97367",
    x1: 375.65,
    y1: -73.4245,
    x2: 296.249,
    y2: 82.8886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.520347,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1D1D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_374_97367",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(116.64 -4.88543) rotate(90) scale(103.68)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101010",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_374_97367",
    x1: 235.778,
    y1: 197.465,
    x2: 215.641,
    y2: 175.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060606"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_374_97367",
    x1: 193.011,
    y1: 150.91,
    x2: 318.446,
    y2: 130.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#201430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605393,
    stopColor: "#170853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200161"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_374_97367",
    x1: 248.729,
    y1: -0.512577,
    x2: 324.832,
    y2: 104.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001C5A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_374_97367",
    x1: 348.994,
    y1: -9.23923,
    x2: 127.748,
    y2: 116.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155363,
    stopColor: "#0C0A79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#200D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030F37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_374_97367",
    x1: 259.654,
    y1: 11.1321,
    x2: 348.702,
    y2: 76.8267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D00AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474971,
    stopColor: "#3A077B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F0BA6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_374_97367",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.4504 38.1593) rotate(100.979) scale(33.4184)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8B6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_374_97367",
    x1: 29.777,
    y1: 52.8262,
    x2: 23.7295,
    y2: 55.2796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#967CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#280EC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E097D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_374_97367",
    x1: 29.7776,
    y1: 52.8262,
    x2: 29.7776,
    y2: 58.7772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8850FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#0D2B96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#552CFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_374_97367",
    x1: 29.7773,
    y1: 52.8262,
    x2: 35.8249,
    y2: 55.2792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6010AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#062696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F0957"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_374_97367",
    x1: 25.1484,
    y1: 58.7773,
    x2: 29.5638,
    y2: 64.8826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#371ED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#4830DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#260D70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_374_97367",
    x1: 28.8519,
    y1: 64.5519,
    x2: 30.5255,
    y2: 57.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#420C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#294EAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F09B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_374_97367",
    x1: 34.4059,
    y1: 58.7773,
    x2: 29.9905,
    y2: 64.8826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2746A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#421182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_374_97367",
    x1: 34.4056,
    y1: 52.8262,
    x2: 22.3105,
    y2: 57.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_374_97367",
    x1: 25.1484,
    y1: 52.8262,
    x2: 37.2436,
    y2: 57.7322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_374_97367",
    x1: 29.777,
    y1: 52.8262,
    x2: 29.777,
    y2: 64.7282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10B981"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_374_97367",
    x1: 25.1484,
    y1: 52.8262,
    x2: 33.9792,
    y2: 65.0366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_374_97367",
    x1: 34.4056,
    y1: 52.8262,
    x2: 25.5748,
    y2: 65.0366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_374_97367",
    x1: 29.777,
    y1: 58.7772,
    x2: 29.0351,
    y2: 64.6342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_374_97367",
    x1: 29.7769,
    y1: 52.8259,
    x2: 27.7932,
    y2: 58.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EE7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10B981",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_374_97367",
    x1: 31.7742,
    y1: 58.7725,
    x2: 27.6656,
    y2: 61.2376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2746A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#421182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_374_97367",
    x1: 29.7769,
    y1: 52.8262,
    x2: 29.7769,
    y2: 53.7199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_374_97367"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.668945,
    width: 324,
    height: 170.331,
    rx: 12.0343,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_374_97367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 525.072,
    height: 456.507,
    fill: "white",
    transform: "translate(-82.3887 -114.058)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_374_97367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.25714,
    height: 11.902,
    fill: "white",
    transform: "translate(25.1484 52.8262)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_374_97367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.01878,
    height: 5.89959,
    fill: "white",
    transform: "translate(27.7646 52.8262)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberDiamond);
export default __webpack_public_path__ + "static/media/member_diamond.af9355411d8f92393d5d0b3ce7faad30.svg";
export { ForwardRef as ReactComponent };